<div class="gt-filter-container">
  <div class="gt-filter-item">
    <select class="gt-filter-select audit-type"
      [(ngModel)]="filter.audit_type"
      (ngModelChange)="onAuditChange()">
      @for (t of audit_data_types; track t) {
        <option [ngValue]="t.value">{{ t.label }}</option>
      }
    </select>
  </div>

  @if (filter.audit_type === 1) {
    <div class="gt-filter-item">
      <label class="filter-label">From</label>
      <input type="date" class="gt-filter-select date-input" [(ngModel)]="dateFrom" />
    </div>
    <div class="gt-filter-item">
      <label class="filter-label">To</label>
      <input type="date" class="gt-filter-select date-input" [(ngModel)]="dateTo" />
    </div>
  }

  @if (filter.audit_type === 2) {
    <div class="gt-filter-item user-filter">
      <label class="filter-label">User</label>
      <div class="gt-multiselect-wrapper">
        <div class="gt-multiselect-btn user-picker-btn"
          role="button"
          tabindex="0"
          (click)="toggleUserMenu($event)"
          (keydown.enter)="toggleUserMenu($event)"
          (keydown.space)="toggleUserMenu($event); $event.preventDefault()">
          <span class="user-picker-label" [class.placeholder]="!selectedUser">
            {{ selectedUserLabel || 'Select user...' }}
          </span>
          @if (selectedUser) {
            <i
              class="fa fa-times user-picker-clear"
              role="button"
              title="Clear"
            (click)="selectUser(null, $event)"></i>
          }
          <i class="fa fa-caret-down"></i>
        </div>
        @if (userMenuOpen) {
          <div
            class="gt-multiselect-dropdown user-picker-dropdown"
            [ngStyle]="userMenuStyle"
            (click)="$event.stopPropagation()">
            <input type="text"
              class="gt-multi-search"
              placeholder="Search..."
              [(ngModel)]="userSearchText"
              (ngModelChange)="onUserSearch()"
              (click)="$event.stopPropagation()" />
              <ul class="gt-multi-list">
                @for (u of filteredUserOptions; track u) {
                  <li
                    [class.selected]="u.value === selectedUser"
                    (click)="selectUser(u, $event)">
                    <i class="fa user-picker-check"
                      [class.fa-check]="u.value === selectedUser"
                    aria-hidden="true"></i>
                    <span>{{ u.name }}</span>
                  </li>
                }
                @if (!loadingUsers && filteredUserOptions.length === 0) {
                  <li class="gt-multi-empty">
                    No users found.
                  </li>
                }
              </ul>
              @if (loadingUsers) {
                <div class="gt-multi-loading">
                  <i class="fa fa-spinner fa-spin"></i> Loading users...
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="gt-filter-item">
      <div class="btn btn-success btn-xs" role="button" (click)="go()">Go</div>
    </div>
  </div>

  @if (gridError) {
    <div class="error-message">{{ gridError }}</div>
  }

  @if (showGrid) {
    <div
      adminGrid
      [gridConfig]="gridConfig!"
      (gridCallback)="onGridCallback($event)"
      (loadingStateChange)="onLoadingStateChange($event)"
      class="gizmo-grid"
    tabindex="2"></div>
  }
